import React from "react";


export default function WhatsAppButton() {
  return (
    <a
      href="https://wa.me/919540155567"
      target="_blank"
      rel="noreferrer"
      className="whatsapp-float"
      aria-label="Chat on WhatsApp"
    >
      <i className="fab fa-whatsapp"></i>
    </a>
  );
}